module.exports = __webpack_public_path__ + "img/Country2-1.cb6a1e11.png";